import { CartItems } from '../components/CartItems/CartItems';

export const CartPage = () => {
  return <CartItems />;
};
